import { Navigate } from 'react-router-dom';

import { ROUTE_PATHS } from '@/config/constants';

export function Home() {
  return <Navigate to={ROUTE_PATHS.VISION_ENRICHMENT} replace />;
}
